// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__254mQ","newExpiryDate":"styles_newExpiryDate__1E1gF","footer":"styles_footer__3d-qo"};